/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuittanceListItem } from './QuittanceListItem';
import {
    QuittanceListItemFromJSON,
    QuittanceListItemFromJSONTyped,
    QuittanceListItemToJSON,
    QuittanceListItemToJSONTyped,
} from './QuittanceListItem';

/**
 * 
 * @export
 * @interface GetQuittanceListResponse
 */
export interface GetQuittanceListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetQuittanceListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<QuittanceListItem>}
     * @memberof GetQuittanceListResponse
     */
    items: Array<QuittanceListItem>;
}

/**
 * Check if a given object implements the GetQuittanceListResponse interface.
 */
export function instanceOfGetQuittanceListResponse(value: object): value is GetQuittanceListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetQuittanceListResponseFromJSON(json: any): GetQuittanceListResponse {
    return GetQuittanceListResponseFromJSONTyped(json, false);
}

export function GetQuittanceListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuittanceListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(QuittanceListItemFromJSON)),
    };
}

export function GetQuittanceListResponseToJSON(json: any): GetQuittanceListResponse {
    return GetQuittanceListResponseToJSONTyped(json, false);
}

export function GetQuittanceListResponseToJSONTyped(value?: GetQuittanceListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(QuittanceListItemToJSON)),
    };
}

